import { render, staticRenderFns } from "./updateCases.vue?vue&type=template&id=b5e276b4"
import script from "./updateCases.vue?vue&type=script&lang=js"
export * from "./updateCases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports